import { createReducer, on, Action } from '@ngrx/store';
import { ITable } from '@common/models/table';
import * as paymentToYouActions from '@feature/payments-to-you/actions/payments-to-you-table';
import { createEntityAdapter, EntityState } from '@ngrx/entity'

export interface State extends EntityState<PaymentsTableInstance> {
}

export class PaymentsTableInstance {
  id: string;
  paymentsTable: ITable;
  loading: boolean;
}

export const paymentsTableAdapter = createEntityAdapter<PaymentsTableInstance>();

export const INITIAL_STATE: State = paymentsTableAdapter.getInitialState({
  paymentsTable: undefined,
  loading: false,
});

const paymentTableReducer = createReducer(INITIAL_STATE,
  on(paymentToYouActions.loadInternal,
    (state, { context, widget }) => {
      return paymentsTableAdapter.upsertOne({
          id: widget.id.toString(),
          loading: true,
          paymentsTable: undefined
        },
        state);
      }),
  on(paymentToYouActions.loadExternal,
    (state, { accountRef, widget }) => {
      return paymentsTableAdapter.upsertOne({
          id: widget.id.toString(),
          loading: true,
          paymentsTable: undefined
        },
        state);
      }),
  on(paymentToYouActions.loadComplete,
    (state, { payload, widget }) => {
        return paymentsTableAdapter.upsertOne({
            id: widget.id.toString(), loading: false, paymentsTable: payload
      }, state);
    }),
);

export function reducer(state: State | undefined, action: Action) {
    return paymentTableReducer(state, action);
}
